import React, { useContext, useEffect, useState } from "react";
import { useRemote, useStorage } from "../../Utils/Utils";
import { BannerContext } from "../../InternalApiApp";
import { useParams } from "react-router";
import { format } from "date-fns";
import Page, { PageContentBodyGrid } from '../Shared/Page/Page';
import PageGridItem from '../Shared/Page/PageGridItem';
import LoadingIcon from "../../components/LoadingIcon";
import AnalyticsGenericTable from "./AnalyticsGenericTable";
import AnalyticsMetricsBanner from './AnalyticsMetricsBanner'
import './AnalyticsPage.scss'


const AnalyticsIndividualPage = ({ name, path, listData, individualPagePath }) => {
    const { setBannerBreadCrumbs } = useContext(BannerContext);
    const params = useParams()
    const storage = useStorage()
    const [list, setList] = useState(null)
    const [loading, setLoading] = useState(true)
    const [currentView, setCurrentView] = useState(null)
    const [allData, setAllData] = useState([])
    const [parentData, setParentData] = useState(null)

    useEffect(() => {
        if (listData) {
            const parentArr = listData.parentEndPoint.split(":")
            const paramId = params[parentArr[1]]
            const parentPath = parentArr[0] + paramId
            storage.getOrFetch(parentPath).then(fetchedParent => {
                setBannerBreadCrumbs({ tab: listData.crumbs.tab, param1: { name: listData.crumbs.column ? fetchedParent[listData.crumbs.column] : getGroupName(fetchedParent, listData.crumbs.addings), id: paramId } })
                setParentData(fetchedParent)
            })

            const theData = Promise.all(
                Object.keys(listData.tabs).map(t => {
                    const string = listData.tabs[t].dataEndPoint
                    const arr = string.split("${")
                    const arr2 = arr[1].split("}")
                    const id = params[arr2[0]]
                    const date = arr2[1].length > 0 ? `/notes?from=2000-01-01&to=${format(new Date(), 'yyyy-MM-dd')}` : ""
                    const path = arr[0] + id + date

                    return storage
                        .getOrFetch(path)
                        .then(fetchedData => { return { name: t, value: fetchedData } });
                })
            )

            theData.then(results => {
                const obj = results.reduce((a, c) => ({ ...a, [c.name]: c.value }), {})
                const string = Object.keys(listData.tabs)[0]
                setAllData(obj)
                setCurrentView(string)
            })
        }
    }, [listData])


    useEffect(() => {
        if (currentView) {
            setList(allData[currentView])
            setLoading(false)
        }
    }, [currentView, allData])

    function changeTab(val) {
        setLoading(true)
        setCurrentView(val)
    }

    function getGroupName(obj, arr) {
        return obj.groupingDetails.groupName + " — " + obj.groupName
    }


    return (
        <Page noBanner showScrollbar>
            <PageContentBodyGrid rowGap="xl" showScrollbar>
                <PageGridItem colSpan="12">
                    <AnalyticsMetricsBanner data={list} guidelines={listData?.metrics} loading={loading} style={{ paddingBottom: '1rem', gap: '3rem' }} parentData={parentData}/>
                    {loading ? <LoadingIcon centered size={48} /> :
                        <AnalyticsGenericTable
                            searchable={listData.tabs[currentView].searchableBy}
                            tableStyle={{ maxWidth: 1200, minWidth: 900 }}
                            colWidths={listData.tabs[currentView].colWidths}
                            headers={listData.tabs[currentView].headers}
                            columns={listData.tabs[currentView].body}
                            data={list}
                            initialSort={listData.tabs[currentView].initialSort}
                            individualPagePath={individualPagePath}
                            searchPlaceholder={"Search " + currentView.toLowerCase() + " (" + list.length + ")"}
                            toggleTabs={listData.toggleTabs}
                            setSelectedTab={(val) => changeTab(val)}
                            selectedTab={currentView}
                        />
                    }
                </PageGridItem>
            </PageContentBodyGrid>
        </Page>
    );
}

export default AnalyticsIndividualPage;